import images from "./images";


const team = [
    {
        id: 1,
        image: images.team1,
        name: "John Smith",
        title: "Firefighter",
        biography: "John Smith is a dedicated firefighter committed to ensuring the safety and protection of our community. Lorem ipsum dolor sit amet consectetur adipisicing elit. Lorem ipsum dolor sit amet consectetur adipisicing elit. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Ad libero error repellendus sequi fugit, cum incidunt reiciendis quia porro ex ipsum aut quisquam magnam maxime exercitationem iure commodi labore pariatur.",
        contacts: {
            phone: "111-222-3344",
            email: "john.smith@gmail.com",
            website: "www.website.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Firefighter - Fire Station #5",
            "Emergency Response Specialist",
            "Fire Safety Instructor",
            "Hazardous Materials Response Team Member"
        ],
        skills: [
            { id: 1, title: "Fire Suppression", progress: 95 },
            { id: 2, title: "Emergency Response", progress: 90 },
            { id: 3, title: "Search and Rescue", progress: 85 }
        ]
    },
    {
        id: 2,
        image: images.team2,
        name: "Jane Doe",
        title: "Firefighter",
        biography: "Jane Doe is a dedicated firefighter committed to ensuring the safety and protection of our community. Lorem ipsum dolor sit amet consectetur adipisicing elit. Lorem ipsum dolor sit amet consectetur adipisicing elit. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Ad libero error repellendus sequi fugit, cum incidunt reiciendis quia porro ex ipsum aut quisquam magnam maxime exercitationem iure commodi labore pariatur.",
        contacts: {
            phone: "111-222-3344",
            email: "jane.doe@gmail.com",
            website: "www.website.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Firefighter - Fire Station #5",
            "Emergency Response Specialist",
            "Fire Safety Instructor",
            "Hazardous Materials Response Team Member"
        ],
        skills: [
            { id: 1, title: "Fire Suppression", progress: 95 },
            { id: 2, title: "Emergency Response", progress: 90 },
            { id: 3, title: "Search and Rescue", progress: 85 }
        ]
    },
    {
        id: 3,
        image: images.team3,
        name: "Michael Johnson",
        title: "Firefighter",
        biography: "Michael Johnson is a dedicated firefighter committed to ensuring the safety and protection of our community. Lorem ipsum dolor sit amet consectetur adipisicing elit. Lorem ipsum dolor sit amet consectetur adipisicing elit. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Ad libero error repellendus sequi fugit, cum incidunt reiciendis quia porro ex ipsum aut quisquam magnam maxime exercitationem iure commodi labore pariatur.",
        contacts: {
            phone: "111-222-3344",
            email: "michael.johnson@gmail.com",
            website: "www.website.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Firefighter - Fire Station #5",
            "Emergency Response Specialist",
            "Fire Safety Instructor",
            "Hazardous Materials Response Team Member"
        ],
        skills: [
            { id: 1, title: "Fire Suppression", progress: 95 },
            { id: 2, title: "Emergency Response", progress: 90 },
            { id: 3, title: "Search and Rescue", progress: 85 }
        ]
    },
    {
        id: 4,
        image: images.team4,
        name: "Emily Davis",
        title: "Firefighter",
        biography: "Emily Davis is a dedicated firefighter who is passionate about protecting her community and ensuring safety. With her expertise and commitment, she consistently goes above and beyond in the line of duty. Emily is always ready to respond to emergencies and offer support wherever needed.",
        contacts: {
            phone: "111-222-3344",
            email: "emily.davis@gmail.com",
            website: "www.website.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Firefighter - Fire Station #5",
            "Emergency Response Specialist",
            "Fire Safety Instructor",
            "Hazardous Materials Response Team Member"
        ],
        skills: [
            { id: 1, title: "Fire Suppression", progress: 95 },
            { id: 2, title: "Emergency Response", progress: 90 },
            { id: 3, title: "Search and Rescue", progress: 85 }
        ]
    }
];

export default team;